module.exports = __webpack_public_path__ + "static/media/eye-icon.f2985e99.svg";